import { LoopbackStepEdge } from '../../components/designer/edges/LoopbackStepEdge';

export const useFlowEdge = () => {
  const edgeTypes = {
    loopbackStep: LoopbackStepEdge,
  };

  return { edgeTypes };
};
